import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const verveCoffeeTransferShippingLabelFileDataSchema = yup.object().shape({
  outShipmentId: yup.string().nullable().optional(),
  transferOrderId: yup.string().nullable().optional(),
  shipDate: yup.string().nullable().optional(),
  shipToName: yup.string().nullable().optional(),
  shipToAddressLine1: yup.string().nullable().optional(),
  shipToAddressLine2: yup.string().nullable().optional(),
  barcode: yup.string().nullable().optional(),
  barcodeText: yup.string().nullable().optional(),
})

export type VerveCoffeeTransferShippingLabelFileData = yup.InferType<
  typeof verveCoffeeTransferShippingLabelFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<VerveCoffeeTransferShippingLabelFileData>

export const verveCoffeeTransferShippingLabelFileMappings: RequiredFileData = {
  outShipmentId: '0928321e-89a3-48c6-80e0-4a574d0a6bc2',
  transferOrderId: '30e6059c-e15c-451d-98f4-aff5be3994c3',
  shipDate: '5912ed45-819b-4916-8c28-90cd6c1c7c3c',
  shipToName: 'b350f2fe-5eac-48ec-8820-4319c13c5ee6',
  shipToAddressLine1: '47e99a0b-f6e7-4b5f-ae91-4854397bf039',
  shipToAddressLine2: 'aefd8633-e880-46a5-a925-3f7de8a00478',
  barcode: 'd7f2f4d5-32a3-457f-8c61-ca22ad22c9b0',
  barcodeText: '03bf572b-07eb-424d-b626-997d52e30ef3',
}
